import { TFunction } from "i18next";
import {
  ACTIVE_STATUS,
  COMPLETED_STATUS,
  WAITING_FOR_SHIPPING,
  WAITING_FOR_INSPECTION,
  ESCALATION_STATUS,
  CLOSED_STATUS,
  ITEM_ACCEPTED_STATUS,
  RESOLVED_STATUS,
  CANCELLED_STATUS_TITLE,
  PENDING_APPROVAL,
  WAITING_SETTLEMENT_STATUS,
  READY_FOR_CASHOUT_STATUS,
  CASHOUT_APPROVED_STATUS,
  EXCEPTIONAL_COMPLETED_STATUS,
} from "../../../../components/contractListItem/constants";
import { ECONTRACT_STATUS } from "../../../../enums";
import {
  EContractType,
  ESenderRole,
} from "../../../../setup/api/services/contract/models";

/** Mirrors the `compTitle` mapping in contractDetails/status/Status.tsx so both views agree on status wording. */
export const getContractStatusTitle = (
  status: ECONTRACT_STATUS,
  t: TFunction<"translation", undefined>,
  contract?: { type?: EContractType; senderRole?: ESenderRole }
): string => {
  switch (status) {
    case ECONTRACT_STATUS.CREATED:
    case ECONTRACT_STATUS.PARTIALLY_PAID:
      return ACTIVE_STATUS;

    case ECONTRACT_STATUS.SUBMITTED:
      return contract?.type === EContractType.BROKERAGE_CONTRACT
        ? t("lbl_join_parties_to_transation")
        : contract?.senderRole === ESenderRole.CUSTOMER
        ? t("lbl_waiting_for_seller_to_join")
        : ACTIVE_STATUS;

    case ECONTRACT_STATUS.COMPLETED:
      return COMPLETED_STATUS;
    case ECONTRACT_STATUS.EXCEPTIONAL_COMPLETED:
      return EXCEPTIONAL_COMPLETED_STATUS;

    case ECONTRACT_STATUS.PENDING_APPROVAL:
    case ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION:
      return PENDING_APPROVAL;

    case ECONTRACT_STATUS.WAITING_FOR_DELIVERY:
      return WAITING_FOR_SHIPPING;
    case ECONTRACT_STATUS.SHIPPED:
      return t("global_status_shipped_title");

    case ECONTRACT_STATUS.ITEM_ACCEPTED:
      return contract?.type === EContractType.QUICK_TRANSACTION
        ? READY_FOR_CASHOUT_STATUS
        : ITEM_ACCEPTED_STATUS;
    case ECONTRACT_STATUS.READY_FOR_CASH_OUT:
      return READY_FOR_CASHOUT_STATUS;

    case ECONTRACT_STATUS.CASH_OUT_APPROVED:
    case ECONTRACT_STATUS.PARTIAL_CASHOUT:
      return CASHOUT_APPROVED_STATUS;

    case ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_CLOSE:
    case ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_RESOLVE:
      return WAITING_SETTLEMENT_STATUS;

    case ECONTRACT_STATUS.ITEM_INSPECTION:
      return WAITING_FOR_INSPECTION;

    case ECONTRACT_STATUS.INSPECTION_ESCALATION:
    case ECONTRACT_STATUS.DELIVERY_ESCALATION:
      return ESCALATION_STATUS;

    case ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER:
    case ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER:
      return RESOLVED_STATUS;

    case ECONTRACT_STATUS.CLOSED_REFUND_CUSTOMER:
    case ECONTRACT_STATUS.CLOSED_RELEASE_PROVIDER:
      return CLOSED_STATUS;

    case ECONTRACT_STATUS.CANCELED:
      return CANCELLED_STATUS_TITLE;

    default:
      return status;
  }
};
